import { ChartLine, CheckSquare, Eye } from '@phosphor-icons/react'
import {
  UI_COLOR_ACCENT_ORANGE,
  UI_COLOR_ACCENT_ORANGE_TEXT,
  UI_COLOR_DANGER_BORDER,
  UI_COLOR_DANGER_TEXT
} from '../../constants/uiColors'

export const LOGIN_BRAND_FEATURES = [
  {
    Icon: Eye,
    text: 'Planifica tu estrategia comercial'
  },
  {
    Icon: CheckSquare,
    text: 'Sigue en tiempo real la ejecución en campo'
  },
  {
    Icon: ChartLine,
    text: 'Mide los resultados y toma decisiones oportunas'
  }
]

export const LOGIN_FIELD_ERRORS = {
  emailRequired: 'El correo es obligatorio.',
  emailInvalid: 'El correo electrónico no es válido.',
  passwordRequired: 'La contraseña es obligatoria.'
}

const EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function isValidLoginEmail(value) {
  return EMAIL_PATTERN.test(String(value).toLowerCase())
}

export const LOGIN_REMEMBER_CHECKBOX_SX = {
  color: '#5B6B7A',
  padding: '6px',
  '&.Mui-checked': { color: UI_COLOR_ACCENT_ORANGE }
}

export const LOGIN_REMEMBER_LABEL_SX = {
  margin: 0,
  alignItems: 'center',
  '& .MuiFormControlLabel-label': {
    fontSize: 14,
    color: '#1A2733',
    lineHeight: 1.3
  }
}

export const LOGIN_FIELD_SX = {
  mb: 2,
  '& .MuiOutlinedInput-root': {
    borderRadius: '14px',
    backgroundColor: '#fff',
    minHeight: 52,
    transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
    '& fieldset': { borderColor: '#D5DEE7', borderWidth: '1.5px' },
    '&:hover fieldset': { borderColor: '#B8C4CE' },
    '&.Mui-focused': {
      backgroundColor: '#fff',
      '& fieldset': {
        borderColor: UI_COLOR_ACCENT_ORANGE,
        borderWidth: '1.5px'
      },
      boxShadow: '0 0 0 4px rgba(255,137,61,0.12)'
    },
    '&.Mui-error fieldset': {
      borderColor: UI_COLOR_DANGER_BORDER,
      borderWidth: '1.5px'
    },
    '&.Mui-error:hover fieldset': {
      borderColor: UI_COLOR_DANGER_TEXT
    },
    '&.Mui-error.Mui-focused': {
      boxShadow: '0 0 0 4px rgba(217, 45, 32, 0.12)',
      '& fieldset': {
        borderColor: UI_COLOR_DANGER_TEXT,
        borderWidth: '1.5px'
      }
    }
  },
  '& .MuiInputLabel-root': { color: '#1A2733' },
  '& .MuiInputLabel-root.Mui-focused': { color: UI_COLOR_ACCENT_ORANGE_TEXT },
  '& .MuiInputLabel-root.Mui-error': { color: UI_COLOR_DANGER_TEXT },
  '& .MuiFormLabel-asterisk': { color: UI_COLOR_ACCENT_ORANGE_TEXT },
  '& .MuiFormHelperText-root': {
    marginLeft: 2,
    marginRight: 2,
    marginTop: '6px',
    fontSize: 13,
    lineHeight: 1.35
  },
  '& .MuiFormHelperText-root.Mui-error': { color: UI_COLOR_DANGER_TEXT },
  '& .MuiOutlinedInput-input': { paddingTop: '14px', paddingBottom: '14px' }
}
